export default __webpack_public_path__ + "static/media/Rule6.07340f33.png";